// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__Z6hsP {
    --page-top-offset: 46px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: var(--container-width);
    max-width: 100%;
    padding: 0 var(--container-padding) 60px;
    max-height: calc(100vh - var(--header-height));
}

.styles_content__3W2J- {
    position: relative;
    /*display: flex;*/
}

.styles_categoriesWrapper__dacCU {
    margin-top: var(--container-margin);
    min-height: 80vh;
}

.styles_header__sH5dW {
    /*font-family: var(--font-secondary);*/

    /*font-size: 35px;*/
    /*font-weight: 700;*/
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 32px;
}

.styles_headerTitle__M3xAS {
    color: var(--primary-color-active);
    margin: 0 0;
}

.styles_categories__a16wq {
    width: var(--container-width);
    max-width: 100%;
    margin: 0 auto 40px;
}

.styles_grid__eRa83 {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 200px; /* minmax(0, 1fr) so first column can shrink and content wraps */
    grid-gap: 40px;
    min-width: 0;
}

.styles_grid__eRa83 > div {
    position: relative;
    min-height: calc(100vh - var(--header-height));
    min-width: 0; /* allow grid cell to shrink so column width is respected */
}

/* TransitionComponent uses position:absolute and sizes to content; force it to fill the cell so inner content can wrap */
.styles_grid__eRa83 > div > div {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
}

/*.content > div:first-child {*/
/*    flex: 1;*/
/*}*/

h4 {
    /*color: var(--alert-color);*/
    /*font-weight: 700;*/
    /*margin: 0 auto;*/
}

.styles_wrapperItems__bREgR,
.styles_wrapper__HLsZw {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    /*padding: 0 116px;*/
    margin: 40px auto 50px;

    width: 100%;
    padding-bottom: 60px;
}

.styles_wrapperBlock__ER5FN {
    display: block;
}

.styles_wrapper__HLsZw:not(.styles_wrapperBlock__ER5FN):not(.styles_wrapperEmpty__KMsj5) {
    display: grid;
    /*display: flex;*/
    min-width: 0; /* allow shrinking so grid wraps within parent width */

    --group-width: 200px;
    grid-template-columns: repeat(auto-fit, minmax(var(--group-width), var(--group-width)));
    column-gap: var(--folder-gap);
    row-gap: 32px;
}

.styles_wrapperFlex__Bh5IG:not(.styles_wrapperBlock__ER5FN):not(.styles_wrapperEmpty__KMsj5) {
    display: flex;
}

.styles_wrapperItems__bREgR {
    grid-gap: var(--folder-item-gap);
}

.styles_popupContainer__hiIrc {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: left;
    display: flex;
    padding-bottom: 120px;
    z-index: 90;
}

.styles_popup__iRv2C {
    position: relative;
    padding: 36px 24px 24px;
    display: flex;
    flex-direction: column;
    width: 485px;
    border: 1px solid #707070;
    background: white;
    margin: auto;
}

.styles_popup__iRv2C h4 {
    color: #000000;
    text-align: left;
    margin-left: 0;
}

.styles_popup__iRv2C p {
    margin: 14px 0 0;
}

.styles_placehodler__tsi8E {
    margin: 0;
    font-size: 30px;
    font-weight: 300;
}

.styles_popup__iRv2C h4 {
    font-size: 20px;
}

.styles_popup__iRv2C p {
    font-size: 20px;
    line-height: 26px;
}

.styles_close__mA0n3 {
    position: relative;
    top: -40px;
    right: -20px;
}

.styles_linearActivity__5nkqN {
    overflow: hidden;
    width: 100%;
    height: 2px;
    background-color: #e5e5e5;
    margin: 24px auto 0;
}

.styles_determinate__Bd-Cq {
    position: relative;
    max-width: 100%;
    height: 100%;
    transition: width 500ms ease-out 1s;
    background-color: var(--primary-color);
}

.styles_indeterminate__XCe3a {
    position: relative;
    width: 100%;
    height: 100%;
}

.styles_indeterminate__XCe3a:before {
    content: '';
    position: absolute;
    height: 100%;
    background-color: var(--primary-color);
    animation: styles_indeterminate_first__JkgiW 1.5s infinite ease-out;
}

.styles_indeterminate__XCe3a:after {
    content: '';
    position: absolute;
    height: 100%;
    background-color: var(--primary-color-active);
    animation: styles_indeterminate_second__o4Jze 1.5s infinite ease-in;
}

.styles_placeholder__5mvvc {
    font-weight: 300;
    font-size: 30px;
}

@keyframes styles_indeterminate_first__JkgiW {
    0% {
        left: -100%;
        width: 100%;
    }
    100% {
        left: 100%;
        width: 10%;
    }
}

@keyframes styles_indeterminate_second__o4Jze {
    0% {
        left: -150%;
        width: 100%;
    }
    100% {
        left: 100%;
        width: 10%;
    }
}

.styles_grid__eRa83 > div:last-child {
    max-height: calc(100vh - var(--header-height) - 108px);
}

.styles_grid__eRa83 > div:last-child aside {
    top: calc(var(--header-height) + 240px) !important;
}

@media (max-height: 1200px) {
    .styles_container__Z6hsP {
        margin: 0 auto;
        padding-bottom: 0;
        --page-top-offset: 16px;
    }

    .styles_categories__a16wq {
        margin: 0 auto 12px;
    }

    .styles_grid__eRa83 > div:last-child {
        min-height: unset;
        max-height: calc(100vh - var(--header-height) - 108px);
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_wrapper__HLsZw:not(.styles_wrapperBlock__ER5FN):not(.styles_wrapperEmpty__KMsj5) {
        /* menu */
        padding-right: 180px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Account/styles.module.css"],"names":[],"mappings":"AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,wCAAwC;IACxC,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;;IAEtC,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2CAA2C,EAAE,gEAAgE;IAC7G,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;IAC9C,YAAY,EAAE,2DAA2D;AAC7E;;AAEA,yHAAyH;AACzH;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,+BAA+B;AAC/B,eAAe;AACf,IAAI;;AAEJ;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,2BAA2B;;IAE3B,oBAAoB;IACpB,sBAAsB;;IAEtB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY,EAAE,sDAAsD;;IAEpE,oBAAoB;IACpB,uFAAuF;IACvF,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IAIZ,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,mEAAqD;AACzD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,mEAAqD;AACzD;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,UAAU;QACV,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,UAAU;QACV,UAAU;IACd;AACJ;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,sDAAsD;IAC1D;AACJ;;AAEA;IACI;QACI,SAAS;QACT,oBAAoB;IACxB;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.container {\n    --page-top-offset: 46px;\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    width: var(--container-width);\n    max-width: 100%;\n    padding: 0 var(--container-padding) 60px;\n    max-height: calc(100vh - var(--header-height));\n}\n\n.content {\n    position: relative;\n    /*display: flex;*/\n}\n\n.categoriesWrapper {\n    margin-top: var(--container-margin);\n    min-height: 80vh;\n}\n\n.header {\n    /*font-family: var(--font-secondary);*/\n\n    /*font-size: 35px;*/\n    /*font-weight: 700;*/\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 32px;\n}\n\n.headerTitle {\n    color: var(--primary-color-active);\n    margin: 0 0;\n}\n\n.categories {\n    width: var(--container-width);\n    max-width: 100%;\n    margin: 0 auto 40px;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 200px; /* minmax(0, 1fr) so first column can shrink and content wraps */\n    grid-gap: 40px;\n    min-width: 0;\n}\n\n.grid > div {\n    position: relative;\n    min-height: calc(100vh - var(--header-height));\n    min-width: 0; /* allow grid cell to shrink so column width is respected */\n}\n\n/* TransitionComponent uses position:absolute and sizes to content; force it to fill the cell so inner content can wrap */\n.grid > div > div {\n    width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n}\n\n/*.content > div:first-child {*/\n/*    flex: 1;*/\n/*}*/\n\nh4 {\n    /*color: var(--alert-color);*/\n    /*font-weight: 700;*/\n    /*margin: 0 auto;*/\n}\n\n.wrapperItems,\n.wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n\n    /*padding: 0 116px;*/\n    margin: 40px auto 50px;\n\n    width: 100%;\n    padding-bottom: 60px;\n}\n\n.wrapperBlock {\n    display: block;\n}\n\n.wrapper:not(.wrapperBlock):not(.wrapperEmpty) {\n    display: grid;\n    /*display: flex;*/\n    min-width: 0; /* allow shrinking so grid wraps within parent width */\n\n    --group-width: 200px;\n    grid-template-columns: repeat(auto-fit, minmax(var(--group-width), var(--group-width)));\n    column-gap: var(--folder-gap);\n    row-gap: 32px;\n}\n\n.wrapperFlex:not(.wrapperBlock):not(.wrapperEmpty) {\n    display: flex;\n}\n\n.wrapperItems {\n    grid-gap: var(--folder-item-gap);\n}\n\n.popupContainer {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    text-align: left;\n    display: flex;\n    padding-bottom: 120px;\n    z-index: 90;\n}\n\n.popup {\n    position: relative;\n    padding: 36px 24px 24px;\n    display: flex;\n    flex-direction: column;\n    width: 485px;\n    border: 1px solid #707070;\n    background: white;\n    margin: auto;\n}\n\n.popup h4 {\n    color: #000000;\n    text-align: left;\n    margin-left: 0;\n}\n\n.popup p {\n    margin: 14px 0 0;\n}\n\n.placehodler {\n    margin: 0;\n    font-size: 30px;\n    font-weight: 300;\n}\n\n.popup h4 {\n    font-size: 20px;\n}\n\n.popup p {\n    font-size: 20px;\n    line-height: 26px;\n}\n\n.close {\n    position: relative;\n    top: -40px;\n    right: -20px;\n}\n\n.linearActivity {\n    overflow: hidden;\n    width: 100%;\n    height: 2px;\n    background-color: #e5e5e5;\n    margin: 24px auto 0;\n}\n\n.determinate {\n    position: relative;\n    max-width: 100%;\n    height: 100%;\n    -webkit-transition: width 500ms ease-out 1s;\n    -moz-transition: width 500ms ease-out 1s;\n    -o-transition: width 500ms ease-out 1s;\n    transition: width 500ms ease-out 1s;\n    background-color: var(--primary-color);\n}\n\n.indeterminate {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.indeterminate:before {\n    content: '';\n    position: absolute;\n    height: 100%;\n    background-color: var(--primary-color);\n    animation: indeterminate_first 1.5s infinite ease-out;\n}\n\n.indeterminate:after {\n    content: '';\n    position: absolute;\n    height: 100%;\n    background-color: var(--primary-color-active);\n    animation: indeterminate_second 1.5s infinite ease-in;\n}\n\n.placeholder {\n    font-weight: 300;\n    font-size: 30px;\n}\n\n@keyframes indeterminate_first {\n    0% {\n        left: -100%;\n        width: 100%;\n    }\n    100% {\n        left: 100%;\n        width: 10%;\n    }\n}\n\n@keyframes indeterminate_second {\n    0% {\n        left: -150%;\n        width: 100%;\n    }\n    100% {\n        left: 100%;\n        width: 10%;\n    }\n}\n\n.grid > div:last-child {\n    max-height: calc(100vh - var(--header-height) - 108px);\n}\n\n.grid > div:last-child aside {\n    top: calc(var(--header-height) + 240px) !important;\n}\n\n@media (max-height: 1200px) {\n    .container {\n        margin: 0 auto;\n        padding-bottom: 0;\n        --page-top-offset: 16px;\n    }\n\n    .categories {\n        margin: 0 auto 12px;\n    }\n\n    .grid > div:last-child {\n        min-height: unset;\n        max-height: calc(100vh - var(--header-height) - 108px);\n    }\n}\n\n@media screen-md-max {\n    .wrapper:not(.wrapperBlock):not(.wrapperEmpty) {\n        /* menu */\n        padding-right: 180px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"container": `styles_container__Z6hsP`,
	"content": `styles_content__3W2J-`,
	"categoriesWrapper": `styles_categoriesWrapper__dacCU`,
	"header": `styles_header__sH5dW`,
	"headerTitle": `styles_headerTitle__M3xAS`,
	"categories": `styles_categories__a16wq`,
	"grid": `styles_grid__eRa83`,
	"wrapperItems": `styles_wrapperItems__bREgR`,
	"wrapper": `styles_wrapper__HLsZw`,
	"wrapperBlock": `styles_wrapperBlock__ER5FN`,
	"wrapperEmpty": `styles_wrapperEmpty__KMsj5`,
	"wrapperFlex": `styles_wrapperFlex__Bh5IG`,
	"popupContainer": `styles_popupContainer__hiIrc`,
	"popup": `styles_popup__iRv2C`,
	"placehodler": `styles_placehodler__tsi8E`,
	"close": `styles_close__mA0n3`,
	"linearActivity": `styles_linearActivity__5nkqN`,
	"determinate": `styles_determinate__Bd-Cq`,
	"indeterminate": `styles_indeterminate__XCe3a`,
	"indeterminate_first": `styles_indeterminate_first__JkgiW`,
	"indeterminate_second": `styles_indeterminate_second__o4Jze`,
	"placeholder": `styles_placeholder__5mvvc`
};
export default ___CSS_LOADER_EXPORT___;
